import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import RadioButton from '../../../../components/RadioButton';
import TextArea from '../../../../components/TextArea';
import { useDispatch, useSelector } from '../../../../store/store';
import { removeWorkExperience, updateWorkExperience } from '../../../../store/signUp/slice';
import { ListItem, WorkExperience } from '../../../../store/signUp/types';
import styles from './style.module.scss';
import DatePicker from '../../../../components/DatePicker';
import { fromDatePickerFormat, toDatePickerFormat } from '../../../../utils/dateHelpers';
import { useEffect, useState } from 'react';
import { errorMessages } from '../../../../config/notification';
import { selectJobList } from '../../../../store/signUp/selectors';
import { getJobListThunk } from '../../../../store/signUp/thunks';

interface Props {
    data: WorkExperience;
};

function WorkExperienceForm(props: Props) {
    const [dateRangeError, setDateRangeError] = useState(false);
    const jobList = useSelector(selectJobList);
    const {
        id,
        to,
        from,
        company,
        location,
        jobTitle,
        roleDescription,
        currentlyworkHere
    } = props.data;

    const dispatch = useDispatch();

    useEffect(() => {
        jobTitle.length > 2 && dispatch(getJobListThunk(jobTitle));
    }, [jobTitle]);

    const updateForm = (key: keyof WorkExperience, value: any) => {
        let newForm = { ...props.data };
        switch (key) {
            case 'from': {
                const formatedDate = fromDatePickerFormat(value);
                newForm = { ...newForm, [key]: formatedDate };
                const check = new Date(formatedDate) > new Date(to);
                setDateRangeError(check);
                break;
            }
            case 'to': {
                const formatedDate = fromDatePickerFormat(value);
                newForm = { ...newForm, [key]: formatedDate }
                const check = new Date(formatedDate) < new Date(from)
                setDateRangeError(check);
                break;
            }
            case 'currentlyworkHere':
                newForm = { ...newForm, [key]: value, to: "" };
                break;
            default:
                newForm = { ...newForm, [key]: value };
                break;
        }

        dispatch(updateWorkExperience(newForm));
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.row}>
                <Input
                    isRequired
                    listShow
                    type='text'
                    label='Job title'
                    list={jobList}
                    value={jobTitle}
                    listIdKey='id'
                    listTitleKey='title'
                    onChange={(val: string) => updateForm('jobTitle', val)}
                    onItemClick={(item: ListItem) => updateForm('jobTitle', item.title)}
                />
                <Input
                    isRequired
                    type='text'
                    label='Company'
                    value={company}
                    onChange={(val: string) => updateForm('company', val)}
                />
            </div>
            <Input
                isRequired
                type='text'
                label='Location'
                value={location}
                onChange={(val: string) => updateForm('location', val)}
            />
            <TextArea
                isRequired
                label='Role description'
                value={roleDescription}
                onChange={(val: string) => updateForm('roleDescription', val)}
            />
            <div className={styles.date}>
                <div className={styles.date_fromTo}>
                    <DatePicker
                        label='From'
                        isRequired
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(from)}
                        setSelectedDate={(val) => updateForm('from', val)}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />
                    {!currentlyworkHere && <DatePicker
                        label='To'
                        isRequired
                        placeholder='MM-DD-YYYY'
                        selectedDate={toDatePickerFormat(to)}
                        setSelectedDate={(val) => updateForm('to', val)}
                        errorMessage={dateRangeError ? 'has-error' : ''}
                    />}
                </div>
                {dateRangeError && (<span className={styles.date_error}>{errorMessages.dateRange}</span>)}
                <RadioButton
                    text="I currently work here"
                    checked={currentlyworkHere}
                    setChecked={(val: boolean) => updateForm('currentlyworkHere', val)}
                />
            </div>
            {id !== 'initial-record' && (<Button
                text='Delete Job'
                type='Error'
                className={styles.delete}
                onClick={() => dispatch(removeWorkExperience(id))}
            />)}
        </div>
    );
};

export default WorkExperienceForm;
